import "./whyUsHero.css";
import HERO_IMAGE from "../../../assets/aboutUs/why-us-hero.webp"

export default function WhyUsHero() {
  return (
    <section className="why-us-hero">
      <img
        src={HERO_IMAGE}
        alt=""
        className="why-us-hero__image"
        width="2000"
        height="1200"
        loading="eager"
        fetchPriority="high"
        decoding="async"
      />
      <div className="why-us-hero__overlay" aria-hidden="true" />

      <div className="why-us-hero__container">
        <div className="why-us-hero__content">
          <div className="why-us-hero__eyebrow">
            <span
              className="why-us-hero__eyebrow-dot"
              aria-hidden="true"
            />
            WHY QUALITAS GLOBAL
          </div>

          <h1 className="why-us-hero__title">
            Why Global AI Companies
            <br />
            <span>Trust Qualitas</span>
          </h1>

          <p className="why-us-hero__description">
            From quality controls and specialist teams to secure,
            scalable delivery, we help AI and data-driven businesses
            move projects forward with confidence.
          </p>

          <a href="/contact-us" className="why-us-hero__button">
            <span>Talk to Our Team</span>
            <span
              className="why-us-hero__button-icon"
              aria-hidden="true"
            >
              ↗
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}
